import { defineStore } from 'pinia'

import { useRefineDerivedIdeasStore } from '~/entities/content/idea/stores/refine-derived-ideas'
import { useRefineIdeasStore } from '~/entities/content/idea/stores/refine-ideas'
import { useRefineQuestionsStore } from '~/entities/content/question/stores/refine-questions'
import { RitualsSwymServices } from '~/entities/content/ritual/api/rituals'
import { useRefineWedosStore } from '~/entities/content/wedo/stores/refine-wedos'

import { CommunityExploreSwymService } from '~/features-swym/community-explore/api/community-explore'
import { CommunityExploreExaleadService } from '~/features-swym/community-explore/servives/exalead-community-explore'
import { ContributionsSwymServices } from '~/features-swym/me-contributions/api/contributions'
import { NetworkActivitiesSwymServices } from '~/features-swym/network-activity/api/network-activities'
import { NetworkByUserSwymServices } from '~/features-swym/network-activity/api/network-by-user'
import { useInvitationsStore } from '~/features-swym/network-invitation/stores/network-invitations'
import { ContentReaderService } from '~/features-swym/widgets/content-reader/api/exalead-content-reader'

import SwymServices, { getContentService as getSwymContentService } from '~/features-shared/content/api/contents'
import { DraftsSwymServices } from '~/features-shared/content/api/drafts'
import ExaleadServices, { getContentService as getExaleadContentService, getExaleadContributionService, getExaleadDraftService, getExaleadRitualService } from '~/features-shared/content/api/exalead-contents'
import { IContentModel } from '~/features-shared/content/interfaces/content-model'
import { useRefineGlobalContentsStore as useRefineGContentsStore } from '~/features-shared/content-feed/composables/refine-contents'
import { useRefineGlobalDraftsContentsStore as useRefineDraftsStore } from '~/features-shared/content-feed/composables/refine-draft-contents'
import { ServiceFetchControllerDrafts } from '~/features-shared/content-feed/controllers/service-fetch-controller-drafts'
import { ServiceFetchControllerWithoutTags } from '~/features-shared/content-feed/controllers/service-fetch-controller-without-tags'
import { ServiceFetchControllerDefault } from '~/features-shared/content-feed/controllers/services-fetch-controller-default'

export const useRefineContentReaderStore = defineStore('refineContentReader', () => {
  return useRefineGContentsStore(
    new ServiceFetchControllerDefault(
      getSwymContentService,
      ContentReaderService,
    ),
  )
})

export const useRefinePostsStore = defineStore(
  'refinePosts',
  () => useRefineGContentsStore(
    new ServiceFetchControllerDefault(
      SwymServices[IContentModel.Post],
      ExaleadServices[IContentModel.Post],
    ),
  ),
)

export const useRefineWikisStore = defineStore(
  'refineWikis',
  () => useRefineGContentsStore(
    new ServiceFetchControllerDefault(
      SwymServices[IContentModel.Wiki],
      ExaleadServices[IContentModel.Wiki],
    ),
  ),
)

export const useRefineConferencesStore = defineStore(
  'refineConferences',
  () => useRefineGContentsStore(
    new ServiceFetchControllerDefault(
      SwymServices[IContentModel.Conference],
      ExaleadServices[IContentModel.Conference],
    ),
  ),
)

export const useRefineSurveysStore = defineStore(
  'refineSurveys',
  () => useRefineGContentsStore(
    new ServiceFetchControllerDefault(
      SwymServices[IContentModel.Survey],
      ExaleadServices[IContentModel.Survey],
    ),
  ),
)

export const useRefineMediasStore = defineStore(
  'refineMedias',
  () => useRefineGContentsStore(
    new ServiceFetchControllerDefault(
      SwymServices[IContentModel.Media],
      ExaleadServices[IContentModel.Media],
    ),
  ),
)

export const useRefineContentsStore = defineStore(
  'refineContents',
  () => useRefineGContentsStore(
    new ServiceFetchControllerDefault(
      getSwymContentService,
      getExaleadContentService,
    ),
  ),
)

export const useRefineGlobalContentsStore = defineStore(
  'refineGlobalContents',
  () => useRefineGContentsStore(
    new ServiceFetchControllerDefault(
      getSwymContentService,
      getExaleadContentService,
    ),
  ),
)

export const useRefineGlobalDraftsStore = defineStore(
  'refineGlobalDrafts',
  () => useRefineDraftsStore(new ServiceFetchControllerDrafts(DraftsSwymServices, getExaleadDraftService)),
)

export const useRefineGlobalContributionsStore = defineStore(
  'refineGlobalContributions',
  () => useRefineGContentsStore(new ServiceFetchControllerDefault(
    ContributionsSwymServices,
    getExaleadContributionService,
  )),
)

export const useRefineNetworkActivitiesStore = defineStore(
  'refineNetworkActivities',
  () => useRefineGContentsStore(
    new ServiceFetchControllerWithoutTags(
      NetworkActivitiesSwymServices,
      getExaleadContentService,
    ),
    true,
  ),
)

export const useRefineNetworkByUserStore = defineStore(
  'refineNetworkByUser',
  () => useRefineGContentsStore(
    new ServiceFetchControllerWithoutTags(
      NetworkByUserSwymServices,
      getExaleadContentService,
    ),
    true,
  ),
)

export {
  useRefineQuestionsStore,
  useRefineWedosStore,
  useRefineIdeasStore,
  useRefineDerivedIdeasStore,
  useInvitationsStore,
}

// Derived types
export const useRefineDerivedPostsStore = defineStore(
  'refineDerivedPosts',
  () => useRefineGContentsStore(
    new ServiceFetchControllerDefault(
      SwymServices[IContentModel.DerivedPost],
      ExaleadServices[IContentModel.Post],
    ),
  ),
)

// rituals
export const useRefineRitualStore = defineStore(
  'refineRituals',
  () => useRefineGContentsStore(
    new ServiceFetchControllerDefault(
      RitualsSwymServices,
      getExaleadRitualService,
    ),
  ),
)

export const useRefineCommunityExplore = defineStore(
  'refineCommunityExplore',
  () => useRefineGContentsStore(
    new ServiceFetchControllerDefault(
      CommunityExploreSwymService,
      CommunityExploreExaleadService,
    ),
  ),
)
